import React from "react";
import BaseModal from "../../components/BaseModal";
import { MODAL_TYPES } from "../../utils/emitter";
import { useTranslation } from "react-i18next";
import useModalActions from "../../hooks/useModalActions";
import { useNavigate } from "react-router-dom";

export default function ReviewSendedModal() {
  const { t } = useTranslation();
  const { closeModal } = useModalActions();
  const navigate = useNavigate();

  const onClose = () => {
    closeModal(MODAL_TYPES.FEEDBACK_SENDED);
    navigate(-1);
  };

  return (
    <BaseModal
      onClose={onClose}
      title={t("modals.feedback_sended.desc")}
      eventTypeModal={MODAL_TYPES.FEEDBACK_SENDED}
    />
  );
}
